import { h } from 'preact';

export default function IconClose(props: AppTypes.AnyProps) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
            {/* eslint-disable-next-line max-len */}
            <path d="M10.7679 8.70271L16.986 2.48453C17.5513 1.91925 17.5513 0.989255 16.986 0.423966C16.4207 -0.141322 15.4908 -0.141322 14.9255 0.423966L8.70728 6.64214L2.4891 0.423966C1.92381 -0.141322 0.993815 -0.141322 0.428526 0.423966C0.145881 0.706611 0 1.08043 0 1.45425C0 1.82807 0.145881 2.20189 0.428526 2.48453L6.64671 8.70271L0.428526 14.9209C0.145881 15.2035 0 15.5773 0 15.9512C0 16.325 0.145881 16.6988 0.428526 16.9814C0.993815 17.5467 1.92381 17.5467 2.4891 16.9814L8.70728 10.7633L14.9255 16.9814C15.4908 17.5467 16.4207 17.5467 16.986 16.9814C17.5513 16.4162 17.5513 15.4862 16.986 14.9209L10.7679 8.70271Z" fill="black" />
        </svg>
    );
}
